export default "__VITE_ASSET__BlQHdejL__";